













import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
import Company from "@/models/company/Company";
import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
import AsiTextField from "@/components/common/AsiTextField";
import AsiRadioGroup from "@/components/common/AsiRadioGroup";
import CompanyUpdate from "@/models/company/CompanyUpdate";
import {AxiosError} from "axios";
import AsiTextarea from "@/components/common/AsiTextarea";

@Component({
	components: {AsiTextarea, AsiRadioGroup, AsiTextField, AsiDialogFormLayout}
})
export default class CompanyUpdateDialogBasicData extends AsiDialogForm {

	@Prop({type: Object, required: true})
	public company!: Company;

	private model: CompanyUpdate | null = null;

	public created(): void {
		this.setCompanyInternal();
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		this.setCompanyInternal();
		const form = this.$refs.form as HTMLFormElement;
		this.reset([], form);
		return event;
	}

	@Watch('company', {deep: true})
	private onCompanyChanged(): void {
		this.setCompanyInternal();
	}

	private setCompanyInternal(): void {
		if (this.model === null) {
			this.model = new CompanyUpdate(this.company);
		} else {
			this.model.setDetailModel(this.company);
		}
	}

	private requestSave(event: Event): void {
		if (this.model === null) return;

		this.loading = true;
		this.$companyService.update(this.company.id, this.model)
			.then(() => this.save(event))
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
